import DiagnosticEntryCanceled from "@/features/maintenance/features/workflows/pages/Show/components/tabs/ForwardingsTab/entries/DiagnosticEntry/status/Canceled";
import DiagnosticEntryCompleted from "@/features/maintenance/features/workflows/pages/Show/components/tabs/ForwardingsTab/entries/DiagnosticEntry/status/Completed";
import DiagnosticEntryOnGoingCheckin from "@/features/maintenance/features/workflows/pages/Show/components/tabs/ForwardingsTab/entries/DiagnosticEntry/status/OnGoingCheckin";
import DiagnosticEntryOnGoingDirective from "@/features/maintenance/features/workflows/pages/Show/components/tabs/ForwardingsTab/entries/DiagnosticEntry/status/OnGoingDirective";
import DiagnosticEntryOnGoingEstablishmentChoice from "@/features/maintenance/features/workflows/pages/Show/components/tabs/ForwardingsTab/entries/DiagnosticEntry/status/OnGoingEstablishmentChoice";
import ExecutionEntryCanceled from "@/features/maintenance/features/workflows/pages/Show/components/tabs/ForwardingsTab/entries/ExecutionEntry/status/Canceled";
import ExecutionEntryCompleted from "@/features/maintenance/features/workflows/pages/Show/components/tabs/ForwardingsTab/entries/ExecutionEntry/status/Completed";
import ExecutionEntryOnGoingCheckin from "@/features/maintenance/features/workflows/pages/Show/components/tabs/ForwardingsTab/entries/ExecutionEntry/status/OnGoingCheckin";
import ExecutionEntryOnGoingDirective from "@/features/maintenance/features/workflows/pages/Show/components/tabs/ForwardingsTab/entries/ExecutionEntry/status/OnGoingDirective";
import ExecutionEntryOnGoingEstablishmentChoice from "@/features/maintenance/features/workflows/pages/Show/components/tabs/ForwardingsTab/entries/ExecutionEntry/status/OnGoingEstablishmentChoice";
import ExecutionEntryOnGoingFinancialReview from "@/features/maintenance/features/workflows/pages/Show/components/tabs/ForwardingsTab/entries/ExecutionEntry/status/OnGoingFinancialReview";
import { MaintenanceForwardingStatus } from "@/features/maintenance/features/workflows/types/forwardings/maintenanceForwarding.type";
import { MaintenanceForwardingsDirectiveEntryKlass } from "@/features/maintenance/features/workflows/types/forwardings/maintenanceForwardingsDirectiveEntryKlasses.type";
import { maintenanceForwardingEntryTypeLabel } from "@shared/maintenance/forwardingEntryLabels";
import ExecutionEntryOnGoingFiscalAssessment from "../../pages/Show/components/tabs/ForwardingsTab/entries/ExecutionEntry/status/OnGoingFiscalAssessment";

export const maintenanceForwardingsDirectiveEntryKlasses: Partial<{
  [DirectiveEntry in MaintenanceForwardingsDirectiveEntryKlass]: {
    label: string;
    status: Partial<{
      [Status in MaintenanceForwardingStatus]: {
        label: string;
        component: React.ComponentType;
      }
    }>
  }
}> = {
  [MaintenanceForwardingsDirectiveEntryKlass.DiagnosticEntry]: {
    label: maintenanceForwardingEntryTypeLabel(MaintenanceForwardingsDirectiveEntryKlass.DiagnosticEntry),
    status: {
      canceled: {
        label: 'Declinado',
        component: DiagnosticEntryCanceled,
      },
      completed: {
        label: 'Finalizado',
        component: DiagnosticEntryCompleted,
      },
      ongoing_checkin: {
        label: 'Pendente de check-in',
        component: DiagnosticEntryOnGoingCheckin,
      },
      ongoing_establishment_choice: {
        label: 'Aguardando resposta do estabelecimento',
        component: DiagnosticEntryOnGoingEstablishmentChoice,
      },
      ongoing_directive: {
        label: 'Análise de diagnóstico e orçamento',
        component: DiagnosticEntryOnGoingDirective,
      },
    },
  },
  [MaintenanceForwardingsDirectiveEntryKlass.ExecutionEntry]: {
    label: maintenanceForwardingEntryTypeLabel(MaintenanceForwardingsDirectiveEntryKlass.ExecutionEntry),
    status: {
      canceled: {
        label: 'Declinado',
        component: ExecutionEntryCanceled,
      },
      completed: {
        label: 'Finalizado',
        component: ExecutionEntryCompleted,
      },
      ongoing_checkin: {
        label: 'Pendente de check-in',
        component: ExecutionEntryOnGoingCheckin,
      },
      ongoing_establishment_choice: {
        label: 'Aguardando resposta do estabelecimento',
        component: ExecutionEntryOnGoingEstablishmentChoice,
      },
      ongoing_directive: {
        label: 'Aguardando execução',
        component: ExecutionEntryOnGoingDirective,
      },
      ongoing_financial_review: {
        label: 'Análise financeira',
        component: ExecutionEntryOnGoingFinancialReview,
      },
      ongoing_fiscal_assessment: {
        label: 'Aguardando envio de notas',
        component: ExecutionEntryOnGoingFiscalAssessment,
      },
    },
  },
}
